/**
 * 全局单例
 *
 * @author yusangeng@outlook.com
 */
var win = window;
var __RUNTIME_IMPORT__ = win.__RUNTIME_IMPORT__;
if (!__RUNTIME_IMPORT__) {
    win.__RUNTIME_IMPORT__ = __RUNTIME_IMPORT__ = {};
}
export function getInstance(key, factory) {
    var value = __RUNTIME_IMPORT__[key];
    if (typeof value === 'undefined') {
        value = __RUNTIME_IMPORT__[key] = factory();
    }
    return value;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2luZ2xldG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3NpbmdsZXRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBRUgsSUFBTSxHQUFHLEdBQUcsTUFBYSxDQUFBO0FBRW5CLElBQUEsa0JBQWtCLEdBQUssR0FBRyxtQkFBUixDQUFRO0FBRWhDLElBQUksQ0FBQyxrQkFBa0IsRUFBRTtJQUN2QixHQUFHLENBQUMsa0JBQWtCLEdBQUcsa0JBQWtCLEdBQUcsRUFBRSxDQUFBO0NBQ2pEO0FBRUQsTUFBTSxVQUFVLFdBQVcsQ0FBSSxHQUFXLEVBQUUsT0FBZ0I7SUFDMUQsSUFBSSxLQUFLLEdBQU0sa0JBQWtCLENBQUMsR0FBRyxDQUFDLENBQUE7SUFFdEMsSUFBSSxPQUFPLEtBQUssS0FBSyxXQUFXLEVBQUU7UUFDaEMsS0FBSyxHQUFHLGtCQUFrQixDQUFDLEdBQUcsQ0FBQyxHQUFHLE9BQU8sRUFBRSxDQUFBO0tBQzVDO0lBRUQsT0FBTyxLQUFLLENBQUE7QUFDZCxDQUFDIn0=